import React from "react";
import styled from "styled-components";
import { useLang } from "../i18n/LanguageContext";

export default function Stats({ businesses, cities, categories }) {
  const { t } = useLang();
  return (
    <Wrap>
      <Stat>
        <span className="num">{businesses}</span>
        <span className="lbl">{t("stats.businesses")}</span>
      </Stat>
      <Stat>
        <span className="num">{cities}</span>
        <span className="lbl">{t("stats.cities")}</span>
      </Stat>
      <Stat>
        <span className="num">{categories}</span>
        <span className="lbl">{t("stats.categories")}</span>
      </Stat>
    </Wrap>
  );
}

const Wrap = styled.section`
  display: flex;
  justify-content: center;
  gap: clamp(28px, 7vw, 80px);
  flex-wrap: wrap;
  padding: 0 clamp(20px, 5vw, 64px) clamp(50px, 8vw, 80px);
`;

const Stat = styled.div`
  text-align: center;
  .num {
    display: block;
    font-family: ${({ theme }) => theme.font.display};
    font-size: clamp(30px, 4.5vw, 46px);
    font-weight: 500;
    color: ${({ theme }) => theme.colors.green};
    line-height: 1;
  }
  .lbl {
    margin-top: 6px;
    display: block;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.inkSoft};
  }
`;
